import { ILoginOIDCRequest } from "../../../model/request/auth/ILoginOIDCRequest";
import { ILoginRespone } from "../../../model/respone/auth/ILoginRespone";
import { IActionTypeBase } from "../IActionTypeBase";

export enum eLoginActions {
    LOGIN_START = "LOGIN_START",
    LOGIN_SUCCESS = "LOGIN_SUCCESS",
    LOGIN_ERROR = "LOGIN_ERROR",

}

export interface ILoginStart extends IActionTypeBase<eLoginActions.LOGIN_START, ILoginOIDCRequest> { }
export interface ILoginSuccess extends IActionTypeBase<eLoginActions.LOGIN_SUCCESS, ILoginRespone> { }
export interface ILoginError extends IActionTypeBase<eLoginActions.LOGIN_ERROR, string | undefined> { }


export type ILoginActions = ILoginStart | ILoginSuccess | ILoginError 
  